<template>
  <div class="flex flex-col gap-4">
    <MarketplaceProductHeader />

    <PageEditor
      class="h-full"
      :page-link="pageLink"
      :is-admin="authStore.isAdmin"
      :meta-title="marketplaceStore.product?.meta?.title || ''"
      :meta-description="marketplaceStore.product?.meta?.description || ''"
      :meta-keywords="marketplaceStore.product?.meta?.keywords || ''"
    />
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useMarketplace } from '~/stores/marketplace'

const route = useRoute()
const localeRoute = useLocaleRoute()
const host = useHost()
const authStore = useAuth()

const pageLink = computed(() => {
  return `${host}${localeRoute(route)?.path}`
})

interface PropsInterface {
  productId: number
}

const props = defineProps<PropsInterface>()
const marketplaceStore = useMarketplace()

const load = async () => {
  try {
    await marketplaceStore.fetchProduct(props.productId)
    useHeadMeta({
      title: () => marketplaceStore.product?.meta?.title || '',
      description: () => marketplaceStore.product?.meta?.description || '',
      keywords: () => marketplaceStore.product?.meta?.keywords || '',
    })
  } catch (error: any) {
    throw useCreateScreenError({ message: 'No such product' })
  }
}

onMounted(async () => {
  await load()
})

onServerPrefetch(async () => {
  await load()
})
</script>
